import { useMemo } from "react"
import { DetailCard, DetailFileDownload, DetailFileModel, DetailItem, extractDOCDetailFiles } from "../../../../../components/layout"
import { DLMSiteApplication } from "../../_models"
import { fieldChanged, isPopulatedArray } from "../../../../../components/helpers"

type Props = {
  dlmAppId: number
  site: DLMSiteApplication
  cardTitle: string
}

export const DOCSplitSiteDetails = ({dlmAppId, site, cardTitle} : Props) => {

  const showFiles = useMemo(() => {
    if (! (site?.docs && isPopulatedArray(site.docs))) return [];
    return extractDOCDetailFiles(site.docs, dlmAppId)
  }, [dlmAppId, site]);

  return (
  <DetailCard cardTitle={cardTitle}>
    { (site?.installerName) &&
    <DetailItem labelText="Installer Name" content={`${site.installerName}`} hasChanged={fieldChanged(site, 'installerName')} />    
    }
    { (site?.projectName) &&
    <DetailItem labelText="Project Name" content={`${site.projectName}`} hasChanged={fieldChanged(site, 'projectName')} />    
    }
    { (site?.projectLocation) &&
    <DetailItem labelText="Project Location" content={`${site.projectLocation}`} hasChanged={fieldChanged(site, 'projectLocation')} />    
    }
    { (site?.coverageArea) &&
    <DetailItem labelText="Total Area of Coverage" content={`${site.coverageArea} ${site.unit}`} hasChanged={fieldChanged(site, ['coverageArea','unit'])} />    
    }
    { (site?.hourRating) &&
    <DetailItem labelText="Hour Rating" content={`${site.hourRating}`} hasChanged={fieldChanged(site, 'hourRating')} />    
    }
    { (site?.bpNumber) &&
    <DetailItem labelText="SCDF Building Plan No." content={`${site.bpNumber}`} hasChanged={fieldChanged(site, 'bpNumber')} />    
    }
    { (site?.otherReference) &&
    <DetailItem labelText="Other Reference" content={`${site.otherReference}`} hasChanged={fieldChanged(site, 'otherReference')} />    
    }
    { isPopulatedArray(showFiles) && 
    <>
    <div className='separator border-gray-200 mb-2' />
    {showFiles.map((dat: DetailFileModel, idx: number) => (
    <DetailFileDownload key={`showfile${idx}`} labelText={dat.showFileTitle} file={dat.showFile} hasChanged={dat.hasChanged} data={dat} canReplace />    
    ))}
    </>
    }
  </DetailCard>
  )

}